<template>
  <modal class="modal" @close="$emit('close')">
    <h4 slot="title">
      {{ $t('saveWeeksSchedule') }}
    </h4>
    <div slot="body" class="body">
      <div class="content">
        <p> {{ $t('youHaveUnsavedChangesInYourWorkWeeksSchedule') }}</p>
        <div class="buttons">
          <button class="clavo-button primary" @click="$emit('save-schedule')">
            {{ $t('save') }}
          </button>
          <button class="clavo-button secondary" @click="$emit('dismiss-schedule')">
            {{ $t('dismissSchedule') }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  name: 'ScheduleLeavePreventPopup',
  components:{
    Modal
  }
}
</script>

<style scoped lang="scss">
.body{
  display: flex;
  justify-content: center;
  .content{
    width: 306px;
    display: flex;
    flex-direction: column;
    p {
      width: 100%;
      font-size: 16px;
      line-height: 24px;
      &:last-of-type{
        margin-bottom: 48px;
      }
    }
    .buttons {
      display: flex;
      margin-bottom: 30px;
      button {
        flex: 1;
        margin-bottom: 16px;
        &:first-of-type {
          margin-right: 10px;
        }
      }
    }
    @include respond-below(sm) {
      width: 100%;  
    }
    @include respond-below(xs) {
      .buttons {
        flex-direction: column;
        button {
          &:first-of-type {
            margin-right: 0;
          }
        }
      }
    }
  }

}
</style>